/* src/app/modules/display/components/menus/product-menu/overflow-calculators/product-menu-overflow-calculator.component.scss */
.menu-section-overflow-calculator {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
}
/*# sourceMappingURL=product-menu-overflow-calculator.component.css.map */
